import { type ChangeEvent, type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { RadioInput } from '../../../base-form-handling'
import { LoginRegistrationRegistrationStateContext } from '../../context/LoginRegistrationRegistrationStateContext'
import { LoginRegistrationRegistrationFormVatInput } from '../LoginRegistrationRegistrationForm/LoginRegistrationRegistrationFormVatInput'

export const LoginRegistrationVatSelectionAndInput: FC = () => {
  const intl = useIntl()

  const { hasVatNumber, setHasVatNumber } = useContext(
    LoginRegistrationRegistrationStateContext,
  )

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setHasVatNumber(event.target.value === 'vat_liability')
  }

  return (
    <div className="mb-1">
      <fieldset className="flex flex-row flex-wrap gap-5">
        <RadioInput
          checked={hasVatNumber}
          dataQaId="professional-account-register-form-vat-liability"
          id="vat_liability"
          key="vat_liability"
          label={intl.formatMessage({
            id: 'general.label.vatExemptionNeeded',
          })}
          name="vat-selection"
          onChange={handleChange}
          type="radio"
          value="vat_liability"
        />
        <RadioInput
          checked={!hasVatNumber}
          dataQaId="professional-account-register-form-vat-exemption"
          id="vat_exemption"
          key="vat_exemption"
          label={intl.formatMessage({
            id: 'general.label.vatExemptionNotNeeded',
          })}
          name="vat-selection"
          onChange={handleChange}
          type="radio"
          value="vat_exemption"
        />
      </fieldset>
      {hasVatNumber ? (
        <div className="mt-3">
          <LoginRegistrationRegistrationFormVatInput />
        </div>
      ) : null}
    </div>
  )
}
